"use client";

import { ReactNode } from "react";
import { Link } from "@/i18n/navigation";

// use the predefined type from react for this purpose
export type LinkProps = React.ComponentProps<typeof Link>;

type SafeLinkProps = Omit<LinkProps, "href"> & {
  href: string; // allow any string, even if not in pathnames
  children: ReactNode;
};

export default function SafeLink({ href, children, ...props }: SafeLinkProps) {
  return (
    // @ts-expect-error – href might not be in typed pathnames
    <Link href={href} {...props}>
      {children}
    </Link>
  );
}
